module.exports = __webpack_public_path__ + "img/bckarrow.14d4d7fe.svg";